import React, { useState } from 'react';
import { Button } from '../common/Button';

interface AffiliateLinkGeneratorProps {
  referralCode: string;
}

export const AffiliateLinkGenerator: React.FC<AffiliateLinkGeneratorProps> = ({ referralCode }) => {
  const [copied, setCopied] = useState(false);
  const referralLink = `${window.location.origin}/?ref=${referralCode}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(referralLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-neutral-200">
      <h3 className="text-lg font-semibold text-neutral-900 mb-4">Your Referral Link</h3>
      <p className="text-sm text-neutral-600 mb-4">
        Share this link with your audience. When they sign up, you'll earn a commission.
      </p>
      
      <div className="flex flex-col sm:flex-row gap-3">
        <div className="flex-grow relative rounded-md shadow-sm">
          <input
            type="text"
            readOnly
            value={referralLink}
            className="block w-full rounded-md border-neutral-300 bg-neutral-50 py-3 px-4 text-neutral-900 focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
          />
        </div>
        <Button 
          onClick={handleCopy}
          variant={copied ? "outline" : "primary"}
          className="sm:w-auto"
        >
          {copied ? 'Copied!' : 'Copy Link'}
        </Button>
      </div>
    </div>
  );
};
